<script setup>
import { useDashboardFullscreen } from 'dashboard/composables/useDashboardFullscreen';

const fullscreen = useDashboardFullscreen();
</script>

<template>
  <button
    v-if="fullscreen"
    v-tooltip.bottom="fullscreen.label.value"
    type="button"
    class="grid size-11 shrink-0 place-items-center rounded-xl text-n-slate-10 transition hover:bg-n-alpha-2 hover:text-n-brand focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
    :aria-label="fullscreen.label.value"
    :aria-pressed="fullscreen.isExpanded.value"
    :disabled="fullscreen.isBusy.value"
    @click="fullscreen.toggle"
  >
    <span
      class="size-5"
      :class="
        fullscreen.isExpanded.value ? 'i-lucide-minimize' : 'i-lucide-maximize'
      "
      aria-hidden="true"
    />
  </button>
</template>
